import AddPracticeRecordResponse from "../models/practiceRecords/AddPracticeRecordResponse";
import PracticeRecord from "../models/practiceRecords/PracticeRecord";
import UserSegmentAggregate from "../models/practiceRecords/UserSegmentAggregate";
import Badge from "../models/practiceRecords/Badge";
import User from "../models/practiceRecords/User";

/**
 * Converts data returned from the add practice record endpoint into an instance of AddPracticeRecordResponse
 * @param json - raw json returned from the add practice record api endpoint. e.g.
 {
    "UserSegmentAggregates": [
        {
            "user_id": 87615,
            "segment_id": 9450,
            "perform_best_accuracy": null,
            "perform_best_stars": null,
            "practice_newest_accuracy": 100,
            "practice_best_accuracy": 100,
            "practice_progress": 100,
            "time_practice": "140.284",
            "time_video": null,
            "time_perform": null,
            "time_total": "140.284",
            "time_modified": "1557772447",
            "time_read_opened": "2019-05-02 13:24:16"
        }
    ],
    "PracticeRecords": [
        {
            "id": 29426393,
            "date": "2019-05-02 09:49:33",
            "detail": "stub",
            "lesson_id": 785,
            "segment_id": 9450,
            "user_id": 87615,
            "duration": 14284,
            "mode": "practice",
            "tempo": 1,
            "hands": "right",
            "scorePercentage": 100,
            "noteScore": 0,
            "bonusScore": 0,
            "totalScore": 0,
            "starScore": 3,
            "missedNotes": 0,
            "wrongNotes": 0,
            "totalNotes": 9,
            "rhythmAccNotes": 0,
            "rhythmInAccNotes": 0,
            "progress": 100
        }
    ],
    "Badges": [],
    "StarsAwarded": 0,
    "TimeSessionPointsAwarded": 1,
    "PerformanceSessionPointsAwarded": 0,
    "TotalSessionPoints": 1,
    "User": {
        "total_points": "118",
        "total_time": "406.284"
    },
}
 */
export function createAddPracticeRecordResponseFromJson(json: object = {}): AddPracticeRecordResponse{
  // @ts-ignore
  const { UserSegmentAggregates: userSegmentAggregatesJson = [], PracticeRecords: practiceRecordsJson = [], Badges: badgesJson = [], StarsAwarded: starsAwarded, TimeSessionPointsAwarded: timeSessionPointsAwarded,  PerformanceSessionPointsAwarded: performanceSessionPointsAwarded, TotalSessionPoints: totalSessionPoints, User: userJson, } = json;
  const practiceRecords = practiceRecordsJson.map(createPracticeRecordFromJson);
  const userSegmentAggregates = userSegmentAggregatesJson.map(createUserSegmentAggregateFromJson);
  const badges = badgesJson.map(createBadgeFromJson);
  const user = createUserFromJson(userJson);
  return new AddPracticeRecordResponse({
    totalSessionPoints,
    timeSessionPointsAwarded,
    starsAwarded,
    practiceRecords,
    userSegmentAggregates,
    badges,
    user,
    performanceSessionPointsAwarded,
  });
}

/**
 * Probably not needed by the ipad app
 * @param json
 */
function createBadgeFromJson(json: object = {}){
  return new Badge(json);
}

/**
 *
 * @param json - e.g.
 {
    "total_points": "118",
    "total_time": "406.284"
}
 */
function createUserFromJson(json: object = {}){
  // @ts-ignore
  const { total_points: totalPoints, total_time: totalTime, level, nextLevel, didLevelUp, pointsUntilNextLevel, pointsAlreadyEarnedTowardNextLevel, } = json;
  return new User({ totalPoints, totalTime, level, nextLevel, didLevelUp, pointsUntilNextLevel, pointsAlreadyEarnedTowardNextLevel, });
}

/**
 *
 * @param json - e.g.
 {
    "id": 29426393,
    "date": "2019-05-02 09:49:33",
    "detail": "stub",
    "lesson_id": 785,
    "segment_id": 9450,
    "user_id": 87615,
    "duration": 14284,
    "mode": "practice",
    "tempo": 1,
    "hands": "right",
    "scorePercentage": 100,
    "noteScore": 0,
    "bonusScore": 0,
    "totalScore": 0,
    "starScore": 3,
    "missedNotes": 0,
    "wrongNotes": 0,
    "totalNotes": 9,
    "rhythmAccNotes": 0,
    "rhythmInAccNotes": 0,
    "progress": 100
}
 */
function createPracticeRecordFromJson(json: object = {}){
  // Uh, maybe use zod here?
  // @ts-ignore
  const { id, date, detail, lesson_id: lessonId, segment_id: segmentId, user_id: userId, duration, mode, tempo, hands, scorePercentage, noteScore, bonusScore, totalScore, starScore, missedNotes, wrongNotes, totalNotes, rhythmAccNotes, rhythmInAccNotes, progress, isSectionComplete, isFirstTimeSectionComplete, hasUnlockedSongs, section_id: sectionId } = json;
  return new PracticeRecord({ id, date, detail, lessonId, segmentId, userId, duration, mode, tempo, hands, scorePercentage, noteScore, bonusScore, totalScore, starScore, missedNotes, wrongNotes, totalNotes, rhythmAccNotes, rhythmInAccNotes, progress, isSectionComplete, isFirstTimeSectionComplete, hasUnlockedSongs, sectionId });
}

/**
 *
 * @param json - e.g.
 {
    "user_id": 87615,
    "segment_id": 9450,
    "perform_best_accuracy": null,
    "perform_best_stars": null,
    "practice_newest_accuracy": 100,
    "practice_best_accuracy": 100,
    "practice_progress": 100,
    "time_practice": "140.284",
    "time_video": null,
    "time_perform": null,
    "time_total": "140.284",
    "time_modified": "1557772447",
    "time_read_opened": "2019-05-02 13:24:16"
}
 */
function createUserSegmentAggregateFromJson(json: object = {}){
  // @ts-ignore
  const { user_id: userId, segment_id: segmentId, perform_best_accuracy: performBestAccuracy, perform_best_stars: performBestStars, practice_newest_accuracy: practiceNewestAccuracy, practice_best_accuracy: practiceBestAccuracy, practice_progress: practiceProgress, time_practice: timePractice, time_video: timeVideo, time_perform: timePerform, time_total: timeTotal, time_modified: timeModified, time_read_opened: timeReadOpened, } = json;
  return new UserSegmentAggregate({ userId, segmentId, performBestAccuracy, performBestStars, practiceNewestAccuracy, practiceBestAccuracy, practiceProgress, timePractice, timeVideo, timePerform, timeTotal, timeModified, timeReadOpened, });
}